import {useState} from "react";
import {
  useCreateStatementDocumentMutation,
  useDeleteStatementDocumentMutation,
  usePatchStatementDocumentMutation, useUploadDocumentToS3BuckerMutation,
} from "../redux/api/reconciliationsApiSlice";


export type StatementDocumentUploader = [
  (broker: string, file: File, isReconciliable: boolean) => Promise<unknown>,
  {
    isLoading: boolean,
    isSuccess: boolean | undefined,
    isError: boolean | undefined,
  }
]

export const useStatementDocumentUploader = (): StatementDocumentUploader => {

  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState<boolean | undefined>(undefined)
  const [error, setError] = useState<boolean | undefined>(undefined)

  const [createDocument] = useCreateStatementDocumentMutation();
  const [uploadToS3] = useUploadDocumentToS3BuckerMutation();
  const [updateDocumentStatus] = usePatchStatementDocumentMutation();
  const [deleteDocument] = useDeleteStatementDocumentMutation();


  const upload = (broker: string, file: File, to_be_reconciled: boolean): Promise<string>=> {
    setLoading(true)
    return createDocument({path: "/", name: file.name, content_type: file.type, broker: broker, to_be_reconciled: to_be_reconciled})
      .unwrap()
      .then((createdDocument) => {
        return uploadToS3({
          file: file,
          url: createdDocument.url,
          fields: createdDocument.fields
        }).unwrap()
          .then(() => {
            return updateDocumentStatus({uuid: createdDocument.uuid, is_valid: true}).unwrap().then(()=> {
              setLoading(false);
              setSuccess(true);
              setError(false);
              return Promise.resolve("Caricamento del documento completato")
            }).catch((err)=> {
              console.log("Could not update document upload status due to an error: ", err)
              setLoading(false);
              setSuccess(false);
              setError(true);
              return Promise.reject("Errore nella finalizzazione dell'upload del documento");
            })
          })
          .catch((err) => {
            return deleteDocument(createdDocument.uuid).unwrap().then(()=> {
              console.log("Could not upload document to bucket due to an error. Statement Document was deleted", err);
              setLoading(false);
              setSuccess(false);
              setError(true);
              return Promise.reject(err);
            }).catch((err)=> {
              console.log("Could not upload document due to an error and Statement Document delete was unsuccessful. ", err);
              setLoading(false);
              setSuccess(false);
              setError(true);
              return Promise.reject("Errore inaspettato nell'upload del documento.");
            })
          })
      }).catch(err => {
        console.error("Could not create document due to an error: ", err);
        setLoading(false);
        setSuccess(false);
              setError(true);
        return Promise.reject("Errore nella creazione del documento");
      });
  }

  return [
    upload,
    {
      isLoading: loading,
      isSuccess: success,
      isError: error,
    }
  ];
}